import React from "react";
import * as yup from 'yup';
import { useForm } from "react-hook-form";

const PickerModel = {
    spanOptions: [
        {
            label: "Clients who...",
            value: ""
        },
        {
            label: "Clients who joined within the last",
            value: "firstSeen_greaterThan" // first seen greater then 60 days ago
        },
        {
            label: "Clients who I have not seen within the last",
            value: "lastSeen_lessThan" // last seen less then 60 days ago
        },
        {
            label: "Clients who have attended within the last",
            value: "lastSeen_greatThan" // last seen greater then 60 days ago
        }
    ],
    dayOptions: [
        {
            label: "",
            value: ""
        },
        {
            label: "7 days",
            value: 7
        },
        {
            label: "14 days",
            value: 14
        },
        {
            label: "30 days",
            value: 30
        },
        {
            label: "60 days",
            value: 60
        },
        {
            label: "90 days",
            value: 90
        },
        {
            label: "6 mo",
            value: 180
        },
        {
            label: "1 year",
            value: 365
        },
    ]
};

export default (props) => {

    const {showFilters, handleApply} = props

    const { register, control, handleSubmit, setValue, getValues, formState, errors } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            span: yup.string().required(),
            days: yup.number().required(),
        })
    });

    const onSubmit = (data) => {

        console.log(data)

        if (handleApply) {
            handleApply(data)
        }

    }


    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className={showFilters ? "" : "d-none"}>


                <div className="d-flex d-row align-items-start">
                    <select name="span" ref={register} className="form-control form-select form-select-sm mb-3 mr-1">
                        {PickerModel.spanOptions.map((val, idx) => {
                            return <option key={idx} value={val.value}>{val.label}</option>
                        })}
                    </select>

                    <select name="days" ref={register} className="form-control form-select form-select-sm mb-3 mr-1">
                        {PickerModel.dayOptions.map((val, idx) => {
                            return <option key={idx} value={val.value}>{val.label}</option>
                        })}
                    </select>

                    <button className="btn btn-primary" type="submit">Apply</button>
                </div>

            </form>
        </>
    );

};